import { Outlet } from 'react-router';
import { TopBar } from './TopBar';
import { SideNav } from './SideNav';
import { OfflineBanner } from './OfflineBanner';

export function AppShell() {
  return (
    <div className="flex min-h-dvh flex-1 flex-col">
      <TopBar />
      <OfflineBanner />
      <div className="flex flex-1">
        <SideNav />
        <main className="min-w-0 flex-1 p-4 sm:p-6 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
